import { Component, HostBinding } from '@angular/core';
import { ChipCoreComponent } from './../chip-core.component';

@Component({
  standalone: false,
  selector: 'campus-suggestion-chip',
  templateUrl: './suggestion-chip.component.html',
  styleUrls: ['../chip.shared.component.scss'],
})
export class SuggestionChipComponent extends ChipCoreComponent {
  @HostBinding('class')
  defaultClasses = [...this.coreClasses];
}
